import React, { useState } from 'react'
import { Link } from "react-router-dom";
import { Envelope, Password, User } from '@phosphor-icons/react'
import './style.css'
import { useMutation } from '@apollo/client';
import { ON_SIGNUP } from '../graphql/mutation';

export default function Signup() {
    const [name, setName] = useState("")
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")

    const [signup, { loading }] = useMutation(ON_SIGNUP)

    const onSignUp = () => {
        if(email && password && name){
            signup({
                variables: {
                    "user": {
                        "email": email,
                        "name": name,
                        "password": password
                    }
                }
            }).then((e)=>{
                localStorage.setItem('xand_user', e?.data?.onSignUp)
                setTimeout(() => {
                    window.location.reload()
                }, 500);
            })
        }
    }

    return (
        <div className='Login'>
            <div className='Login_Con'>
                <h2>Create your account</h2>
                <form onSubmit={(e)=>{
                    e?.preventDefault()
                    onSignUp()
                }}>
                    <div className='Login_Con_Input'>
                        <div className='Login_Con_Input_Icon'>
                            <User />
                        </div>
                        <input value={name} onChange={(e) => setName(e?.target?.value)} placeholder='Name' />
                    </div>
                    <div className='Login_Con_Input'>
                        <div className='Login_Con_Input_Icon'>
                            <Envelope />
                        </div>
                        <input value={email} onChange={(e) => setEmail(e?.target?.value)} placeholder='Email' />
                    </div>
                    <div className='Login_Con_Input'>
                        <div className='Login_Con_Input_Icon'>
                            <Password />
                        </div>
                        <input value={password} onChange={(e) => setPassword(e?.target?.value)} placeholder='Password' />
                    </div>
                    <button>{loading ? "Please wait" : "Sign Up"}</button>
                </form>
                <p>Already have an account? <Link to={'/login'}>Login</Link></p>
            </div>
        </div>
    )
}
